var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.125 8.8125H29.875C26.6437 8.8125 24 11.4562 24 14.6875V22.0312C23.1187 22.0312 22.5312 22.6187 22.5312 23.5V27.9062C22.5312 28.7875 23.1187 29.375 24 29.375V32.3125C23.1187 32.3125 22.5312 32.9 22.5312 33.7812V41.125C22.5312 42.0062 23.1187 42.5938 24 42.5938V79.3125C24 82.5437 26.6437 85.1875 29.875 85.1875H65.125C68.3563 85.1875 71 82.5437 71 79.3125V14.6875C71 11.4562 68.3563 8.8125 65.125 8.8125ZM68.0625 79.3125C68.0625 80.9281 66.7406 82.25 65.125 82.25H29.875C28.2594 82.25 26.9375 80.9281 26.9375 79.3125V14.6875C26.9375 13.0719 28.2594 11.75 29.875 11.75H35.75C35.75 13.3656 37.0719 14.6875 38.6875 14.6875H56.3125C57.9281 14.6875 59.25 13.3656 59.25 11.75H65.125C66.7406 11.75 68.0625 13.0719 68.0625 14.6875V79.3125Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8438 38.1875H51.9062V41.125H54.8438V38.1875Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9688 38.1875H46.0312V41.125H48.9688V38.1875Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2812 60.2188H31.3438V63.1562H34.2812V60.2188Z",
    fill: "#3EFFB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2812 66.0938H31.3438V69.0312H34.2812V66.0938Z",
    fill: "#3EFFB3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1875 54.3438H37.2188V57.2812H62.1875V54.3438Z",
    fill: "#3EFFB3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1875 71.9688H37.2188V74.9062H62.1875V71.9688Z",
    fill: "#3EFFB3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8438 60.2188H37.2188V63.1562H54.8438V60.2188Z",
    fill: "#3EFFB3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8438 66.0938H37.2188V69.0312H54.8438V66.0938Z",
    fill: "#3EFFB3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2812 54.3438H31.3438V57.2812H34.2812V54.3438Z",
    fill: "#3EFFB3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2812 71.9688H31.3438V74.9062H34.2812V71.9688Z",
    fill: "#3EFFB3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7812 47C59.3969 47 60.7188 45.6781 60.7188 44.0625V24.9688C60.7188 23.3531 59.3969 22.0312 57.7812 22.0312H37.2188C35.6031 22.0312 34.2812 23.3531 34.2812 24.9688V44.0625C34.2812 45.6781 35.6031 47 37.2188 47H57.7812ZM44.5625 24.9688H50.4375V29.375H44.5625V24.9688ZM37.2188 24.9688H41.625V29.375C41.625 30.9906 42.9469 32.3125 44.5625 32.3125H50.4375C52.0531 32.3125 53.375 30.9906 53.375 29.375V24.9688H57.7812V44.0625H37.2188V24.9688Z",
    fill: "#3EFFB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.52b8ec1ffccba21c59f3d2f0e4f3c7f6.svg";
export { ForwardRef as ReactComponent };